import { Popover } from 'antd'
import WizrButton from '../WizrButton'
import MoreIcon from '../../assets/icons/More'
import EditIcon from '../../assets/icons/EditIcon'
import { dispatchDisableTenants, dispatchDeleteTenants, dispatchListTenants, dispatchupdateUserView, dispatchEnableTenants } from '../../redux/actions/content'
import { useNavigate } from 'react-router-dom'
import WizrFlexLayout from '../../components/WizrFlexLayout'
import DeleteIcon from '../../assets/icons/DeleteIcon'
import View from '../../assets/icons/View'
import Disable from '../../assets/icons/Disable'
import { MODAL_TYPES, useWizrModalContext } from '../../providers/modal/WizrModalProvider'
import styled from 'styled-components'
import { useAuth } from '../../authContext'

// const currentAppDetails = useCurrentAppDetailsSelector()

// Helper function to remove non-serializable data (functions, etc.) from an object
const getSerializableData = (obj: any): any => {
  if (obj === null || obj === undefined) return obj
  
  // Handle primitives
  if (typeof obj !== 'object') return obj
  
  // Handle Date objects - convert to ISO string
  if (obj instanceof Date) return obj.toISOString()
  
  // Handle arrays
  if (Array.isArray(obj)) return obj.map(getSerializableData)
  
  // Handle RegExp and other special objects
  if (obj instanceof RegExp) return obj.toString()
  
  // Handle plain objects
  const result: any = {}
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      try {
        const value = obj[key]
        // Skip functions, symbols, and undefined
        if (typeof value !== 'function' && typeof value !== 'symbol' && value !== undefined) {
          result[key] = getSerializableData(value)
        }
      } catch (e) {
        // Skip properties that can't be accessed
        continue
      }
    }
  }
  return result
}

const TenantActionPopoverContent = (tenantDetails: any): JSX.Element => {
  const { showModal, hideModal } = useWizrModalContext()
  const { hasAcces } = useAuth();
  const navigate = useNavigate()
  const onEditAction = () => {
    // Extract only serializable data to avoid DataCloneError
    // Handle both cases: nested tenantDetails or direct tenantDetails
    const rawDetails = tenantDetails?.tenantDetails ?? tenantDetails
    let serializableDetails: any
    
    try {
      // First try our custom serialization
      serializableDetails = getSerializableData(rawDetails)
      // Double-check by attempting JSON serialization (this will throw if there are still non-serializable values)
      JSON.stringify(serializableDetails)
    } catch (e) {
      // Fallback: use JSON.parse(JSON.stringify()) which automatically removes functions
      // This has limitations with Date objects, but should work for most cases
      try {
        serializableDetails = JSON.parse(JSON.stringify(rawDetails))
      } catch (jsonError) {
        // If that also fails, create a minimal object with only known safe properties
        serializableDetails = {
          tenant_name: rawDetails?.tenant_name,
          tenant_type: rawDetails?.tenant_type,
          user_domains: rawDetails?.user_domains,
          tenant_domain: rawDetails?.tenant_domain,
          app_domain_prefix: rawDetails?.app_domain_prefix,
          region: rawDetails?.region,
          packages: rawDetails?.packages,
          product_key: rawDetails?.product_key,
          status: rawDetails?.status,
          product_name: rawDetails?.product_name,
          industry_type: rawDetails?.industry_type,
          vector_config_id: rawDetails?.vector_config_id,
          general_apps: rawDetails?.general_apps,
          id: rawDetails?.id,
          tenant_id: rawDetails?.tenant_id
        }
      }
    }
    
    navigate('/tenantdetails', { state: { action: 'edit', details: serializableDetails } })
  }
  const onViewAction = () => {
    dispatchupdateUserView({
      activeKey: "users",
      tenantId: tenantDetails?.tenantDetails?.tenant_id
    })
  }
  const onDeleteAction = async () => {
    showModal(MODAL_TYPES.CONFIRMATION, {
      text: `Are you sure you want to delete ${tenantDetails?.tenantDetails?.tenant_name}`,
      buttontext: "Confirm",
      onConfirm: deleteTenant,
      onCancel: hideModal

    })
  }
  const deleteTenant = async () => {
    hideModal()
    await dispatchDeleteTenants(tenantDetails?.tenantDetails?.id)
    await dispatchListTenants()
  }
  const onDisableAction = async () => {
    if (tenantDetails?.tenantDetails?.status === "active") {
      await dispatchDisableTenants(tenantDetails?.tenantDetails?.id)
    }
    else {
      await dispatchEnableTenants(tenantDetails?.tenantDetails?.id)
    }
    await dispatchListTenants()

  }
  return (
    <WizrFlexLayout textAlign='left' background='#FFF'>

      <WizrButton
        icon={<EditIcon />}
        text='Edit'
        type='text'
        onClick={() => { onEditAction() }}
        justifyContent='flex-start'
        disabled={!hasAcces('edit_tenants')}

      />
      <WizrButton
        icon={<View />}
        text='View User'
        type='text'
        onClick={() => { onViewAction() }}
        justifyContent='flex-start'
        disabled={!hasAcces('view_users')}

      />
      <WizrButton
        icon={<Disable />}
        text={tenantDetails?.tenantDetails?.status === "active" ? 'Disable' : "Enable"}
        type='text'
        onClick={() => { onDisableAction() }}
        justifyContent='flex-start'
        disabled={!hasAcces('edit_tenants')}

      />
      <WizrButton
        icon={<DeleteIcon />}
        text='Delete'
        type='text'
        onClick={() => { onDeleteAction() }}
        justifyContent='flex-start'
        disabled={!hasAcces('delete_tenants')}
      />
    </WizrFlexLayout>
  )
}

const TenantActionPopOver = (tenantDetails: any): JSX.Element => {


  return (
    <Popover
      content={
        <TenantActionPopoverContent
          tenantDetails={tenantDetails?.tenantDetails}
        />
      }
      trigger='click'
    >
      <StyledButton icon={<MoreIcon />} text='' type='text' style={{ height: '40px', width: '40px', borderRadius: '50px' }} />
    </Popover>
  )
}

export default TenantActionPopOver

const StyledButton = styled(WizrButton)`
border-radius: 50%;
width: 20px;
height: 20px;
padding-right: 8px;
justify-content: center;
align-items: center;
  /* Default styles */
  path {
    stroke: #999B9F; /* Default stroke color */
    transition: stroke 0.3s ease; /* Smooth transition for color change */
  }

  /* Hover styles */
  &:hover path {
    stroke: #1D1F22
  }
`;



